import { createSlice } from "@reduxjs/toolkit";

const loadStoredAuth = () => {
  try {
    const token = localStorage.getItem("companyAdminToken");
    const raw = localStorage.getItem("companyAdminUser");
    const data = raw ? JSON.parse(raw) : null;
    return {
      token: token || null,
      user: data?.user ?? null,
      company: data?.company ?? null,
    };
  } catch {
    return { token: null, user: null, company: null };
  }
};

const initialState = loadStoredAuth();

const authSlice = createSlice({
  name: "companyAuth",
  initialState,
  reducers: {
    setCredentials: (state, { payload }) => {
      state.token = payload.token ?? state.token;
      if (payload.user != null) state.user = payload.user;
      if (payload.company != null) state.company = payload.company;
    },
    clearCredentials: (state) => {
      state.token = null;
      state.user = null;
      state.company = null;
    },
  },
});

export const { setCredentials, clearCredentials } = authSlice.actions;

export const selectToken = (state) => state.companyAuth.token;
export const selectCompanyUser = (state) => state.companyAuth.user;
export const selectCompany = (state) => state.companyAuth.company;
export const selectIsAuthenticated = (state) => !!state.companyAuth.token;

export default authSlice.reducer;
